<template>
  <div class="row main-content">
    <div class="col">
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <h1 class="page-title font-custom text-uppercase mt-3">
          {{ $t('title.affiliate.edit') }}
        </h1>

        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t('error.'+`${responseErr}`) }}
          </strong>
        </div>
        <div class="card mb-4">
          <div
            v-if="hasPermission('affiliates:read') && affiliate"
            class="card-body bg-light"
          >
            <BaseButton
              type="button"
              class="btn btn-primary rounded-pill font-inverted"
              @click-base-button-event-emitter="showDetails(affiliate)"
            >
              {{ $t('button.consult') }}
            </BaseButton>
          </div>
        </div>
        <div
          v-if="$store.state.affiliates.affiliateDetail"
        >
          <div
            id="accordionDetail"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingDetail"
              data-bs-toggle="collapse"
              href="#collapseDetail"
              aria-expanded="false"
              aria-controls="collapseDetail"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.affiliate.detail.detail') }}
            </div>
            <div
              id="collapseDetail"
              aria-labelledby="headingDetail"
              data-bs-parent="#accordionDetail"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.contractId') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.affiliates.affiliateDetail.contractId) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.distributorId') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.affiliates.affiliateDetail.distributorId) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.productId') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.affiliates.affiliateDetail.productId) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.creationDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.affiliates.affiliateDetail.creationDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.status') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.affiliates.affiliateDetail.status) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.activationDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.affiliates.affiliateDetail.activationDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.affiliate.detail.inactivationDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.affiliates.affiliateDetail.inactivationDate) }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionPresta"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingPresta"
              data-bs-toggle="collapse"
              href="#collapsePresta"
              aria-expanded="false"
              aria-controls="collapsePresta"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.affiliate.detail.providerList') }}
            </div>
            <div
              id="collapsePresta"
              aria-labelledby="headingPresta"
              data-bs-parent="#accordionPresta"
              class="card-body collapse"
            >
              <div class="card mb-4">
                <div class="card-body bg-light">
                  <BaseButton
                    type="button"
                    class="btn btn-primary rounded-pill font-inverted"
                    @click-base-button-event-emitter="showAddProviderDialog()"
                  >
                    {{ $t('label.affiliate.detail.addProviderLowerCase') }}
                  </BaseButton>
                  <AddProviderDialog
                    ref="addProviderDialogRef"
                    :affiliate-detail="$store.state.affiliates.affiliateDetail"
                  />
                  <EditProviderDialog
                    ref="editProviderDialogRef"
                    :affiliate-detail="$store.state.affiliates.affiliateDetail"
                  />
                  <DeleteProviderDialog
                    ref="deleteProviderDialogRef"
                    :affiliate-detail="$store.state.affiliates.affiliateDetail"
                  />
                  <AddMerchantDialog
                    ref="addMerchantDialogRef"
                    :affiliate-detail="$store.state.affiliates.affiliateDetail"
                  />
                  <EditMerchantDialog
                    ref="editMerchantDialogRef"
                    :affiliate-detail="$store.state.affiliates.affiliateDetail"
                  />
                  <DeleteMerchantDialog
                    ref="deleteMerchantDialogRef"
                    :affiliate-detail="$store.state.affiliates.affiliateDetail"
                  />
                </div>
              </div>
              <!-- Attention : 'provider.providerId' may contain special characters, index is used instead-->
              <div
                v-for="(provider, index) in $store.state.affiliates.affiliateDetail.providerList"
                :key="provider.id"
                class="card mb-4"
              >
                <div class="card-body bg-light">
                  <div class="container pb-3">
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t('label.affiliate.detail.providerId') }}
                      </div>
                      <div class="col">
                        {{ $filters.nullFilter(provider.providerId) }}
                      </div>
                      <div class="col text-end">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom m-1"
                          @click="showEditProviderDialog(provider)"
                        >
                          {{ $t('button.edit') }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom m-1"
                          @click="showDeleteProviderDialog(provider)"
                        >
                          {{ $t('button.delete') }}
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3 text-end">
                        {{ $t('label.affiliate.detail.connectionMode') }}
                      </div>
                      <div class="col">
                        {{ $filters.nullFilter(provider.connectionMode) }}
                      </div>
                    </div>
                  </div>
                  <div class="card mb-4">
                    <div class="card-body bg-light">
                      <BaseButton
                        type="button"
                        class="btn btn-primary rounded-pill font-inverted"
                        @click-base-button-event-emitter="showAddMerchantDialog(provider)"
                      >
                        {{ $t('label.affiliate.detail.addMerchantLowerCase') }}
                      </BaseButton>
                    </div>
                  </div>
                  <div class="card rounded-0 mb-4">
                    <!-- Attention : 'provider.providerId' may contain special characters, index is used instead-->
                    <div
                      class="card-header font-accent fw-bold"
                      data-bs-toggle="collapse"
                      :href="'#provider' + index"
                    >
                      {{ $t('label.affiliate.detail.merchantList') }}
                    </div>
                    <div
                      :id="'provider' + index"
                      class="card-body collapse"
                    >
                      <div
                        v-for="merchant in provider.merchantList"
                        :key="merchant.id"
                        class="card mb-4"
                      >
                        <div class="card-body">
                          <div class="row">
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.merchantId') }}
                            </div>
                            <div class="col">
                              {{ $filters.nullFilter(merchant.merchantId) }}
                            </div>
                            <div class="col text-end">
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom m-1"
                                @click="showEditMerchantDialog(provider,merchant)"
                              >
                                {{ $t('button.edit') }}
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom m-1"
                                @click="showDeleteMerchantDialog(provider,merchant)"
                              >
                                {{ $t('button.delete') }}
                              </button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.structureId') }}
                            </div>
                            <div class="col">
                              {{ $filters.nullFilter(merchant.structureId) }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.channelList') }}
                            </div>
                            <div class="col">
                              <template v-for="channel in merchant.channelList">
                                {{ $filters.nullFilter(channel) }},
                              </template>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-3 text-end">
                              {{ $t('label.affiliate.detail.messageList') }}
                            </div>
                            <div class="col">
                              <template v-for="message in merchant.messageList">
                                {{ $filters.nullFilter(message) }},
                              </template>
                            </div>
                          </div>
                          <!-- div class="row" v-for="filteringGroup in merchant.filteringGroupList" :key="filteringGroup.id">
                            <div class="col-3 text-end"> {{ $t('label.affiliate.detail.'+ filteringGroup.filteringGroupId) }} </div>
                            <div class="col"><template v-for="filtering in filteringGroup.filteringList"> {{ $filters.nullFilter(filtering.value) }}, </template></div>
                          </div -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmationDialog
      ref="confirmationDialogRef"
      @action-confirmed-event="confirmedAction()"
    />
    <SuccessDialog ref="successDialogRef" />
    <ErrorDialog ref="errorDialogRef" />
    <goTopButton />
  </div>
</template>

<script src="./AffiliateEdit.js"></script>

<style src="./AffiliateEdit.scss" scoped lang="scss"></style>
